import { render } from "./TemplatesEditor.vue?vue&type=template&id=b1c54fc0"
import script from "./TemplatesEditor.vue?vue&type=script&lang=js"
export * from "./TemplatesEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__